// TODO track nav height

const headerGroup = document.getElementById("header-group");
if (!headerGroup) throw new Error("Header group not found");

const update = () => {
  const height = headerGroup.getBoundingClientRect().bottom;
  document.documentElement.style.setProperty(
    "--header-group-dynamic-height",
    `${height}px`,
  );
};

// Update on resize
new ResizeObserver(update).observe(headerGroup);

// Update on scroll
window.addEventListener("scroll", update, { passive: true });

// Initial height
update();
